<template>
  <div
    id="header-bar"
    v-scroll:top="doScroll"
    :style="sizeMod"
    class=" z-20 w-full h-1/6 min-h-75p bg-white flex flex-row align-items-center p-3 overflow-auto fixed top-0"
  >
    <div
      class="flex flex-row-reverse md:flex-col content-between md:content-end items-end h-full w-2/3 relative "
    >
      <div
        id="logo-div"
        class="h-full md:h-2/3 w-1/2 md:w-full relative flex flex-row-reverse"
        :style="logoSpacing"
      >
        <img
          alt="logo"
          class="object-scale-down w-full md:w-1/2 max-h-full cursor-pointer"
          :style="logoWidth"
          src="../assets/logo_wp-v3.png"
          @click="engageEvent"
        >
      </div>
      <xn-nav-list
        class="w-1/2 h-full md:h-1/3"
        :items="navList"
      />
    </div>
    <div class="h-full w-1/3 relative flex flex-row-reverse">
      <!-- <button
        class="btn justify-self-end" 
        @click="logoEvent"
      >
        Start New Part
      </button> -->
    </div>
  </div>
</template>
<script>
import XnNavList from './structure/navigation/XnNavList.vue'
export default {
  name: 'HeaderBar',
  components: { XnNavList,  },
  props: { scrollCollapse: { type: Boolean, default: false } },
  data () {
    return {
      showIcon: false,
      toTop: 0,
      prevToTop: 0,
      navList: [
        { text: 'FAQ', value: 'https://aproe.com/waterjet-faq/' },
        { text: 'Guidelines', value: 'https://aproe.com/file-guidelines/' },
        { text: 'Contact', value: 'https://aproe.com/contact/' },
      ],
    }
  },
  computed: {
    environment (){
      return process.env.NODE_ENV
    },
    sizeMod () {
      return {
        'max-height': 'calc(25% - ' + this.toTop + 'px)',
      }
    },
    logoSpacing () {
      if (this.toTop < 3) {
        return {
          'padding-right': 0,
        }
      } else if (this.toTop < 55) {
        return {
          'padding-right': this.toTop + '%',
        }
      } else {
        return {
          'padding-right': '55%',
        }
      }
    },
    logoWidth () {
      if (!this.scrollCollapse) {
        return {}
      }
      if (this.toTop < 10) {
        return {
          width: '50%',
        }
      } else if (this.toTop < 200) {
        return {
          width: 50 + this.toTop / 2 + '%',
        }
      } else {
        return {
          width: '100%',
        }
      }
    },
  },
  methods: {
    engageEvent () {
      window.open('https://aproe.com', '_blank', 'noopener')
    },
    doScroll (offset) {
      if (this.scrollCollapse) {
        if (Math.abs(this.toTop + offset) > 3 || offset === 0) {
          if (this.prevToTop + offset !== 0) {
            this.prevToTop = this.toTop
            this.toTop = -1 * offset
          }
        }
      }
    },
    logoEvent () {
      window.scrollTo(0, 0)
      this.$router.push('/')
    },
  },
}
</script>
<style scoped>
#header-bar {
  transition: height 300ms ease;
}
#logo-div {
  transition: padding 300ms ease;
}
</style>
